import {AppStore} from "../../desktop";
import {TabsActionTypes} from "../tabs";
import {Tenant} from "../../models/Tenant";
import {TenantActionTypes} from "./types";

// todo add tabId logic to other item loadings as well

export const actionTenantFetchRequest = (tabId: string) => {
	AppStore.dispatch({type: TenantActionTypes.FETCH_ONE_REQUEST, payload: tabId})
}

export const actionTenantFetchCompleted = (tenant: Tenant, tabId: string) => {
	AppStore.dispatch({type: TenantActionTypes.FETCH_ONE_COMPLETED, payload: tenant})
	// AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM_FOR_TAB_ID, payload: {tabId: tabId, item: tenant}})
}

export const actionTenantSaveRequest = (tenant: Tenant) => {
	AppStore.dispatch({type: TenantActionTypes.SAVE_REQUEST, payload: tenant})
}

export const actionTenantSaveCompleted = (tenant: Tenant) => {
	AppStore.dispatch({type: TenantActionTypes.SAVE_COMPLETED, payload: tenant})
}
